import { get, post, put, remove } from 'api/request';
import urls from 'configs/urls';

export const getSpecialities = () =>
  get({ Language: 'en-EG' }, false, urls.servicesUrl.getSpecialities);

export const getServicesList = ({ data }) => get(null, false, urls.servicesUrl.getServices, data);

export const addService = data => post(null, false, urls.servicesUrl.addService, data);

export const editService = data =>
  put(null, false, `${urls.servicesUrl.editService}/${data.serviceKey}`, data);

export const deleteService = data =>
  remove(null, false, `${urls.servicesUrl.deleteService}/${data.serviceKey}`);

export const getAlternativeNames = serviceKey =>
  get(null, false, `${urls.servicesUrl.getServices}/${serviceKey}/alternative-names`);

export const updateAlternativeNames = (serviceKey, alternativeNames) =>
  put(
    null,
    false,
    `${urls.servicesUrl.getServices}/${serviceKey}/alternative-names`,
    alternativeNames,
  );
